"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerEmailSettingsEnum = void 0;
var PartnerEmailSettingsEnum;
(function (PartnerEmailSettingsEnum) {
    PartnerEmailSettingsEnum["DAILY"] = "daily";
    PartnerEmailSettingsEnum["PER_ORDER"] = "per order";
    PartnerEmailSettingsEnum["NEVER"] = "never";
})(PartnerEmailSettingsEnum = exports.PartnerEmailSettingsEnum || (exports.PartnerEmailSettingsEnum = {}));
//# sourceMappingURL=partner-email-settings.enum.js.map